<!-- 应用组件 -->
<template>
    <div class="container">
        <div class="content" v-if="this.$route.path == '/admin/assembly'" >
            <div class="title">营销模块</div>
            <div class="display_flex mt-24 mb-24">
                <div class="card" @click="goWxpacket">
                    <img src="../../assets/red_envelope.png">
                    <div class="display_flex flex-col">
                        <div class="card_title">微信关注扫码领红包</div>
                        <div>要求用户关注公众号，领取红包</div>
                    </div>
                </div>
                <!-- <div class="card ml-24" @click="goIntegral">
                    <img src="../../assets/integral.png">
                    <div class="display_flex flex-col">
                        <div class="card_title">积分兑换</div>
                        <div>累计积分兑换商品，拉新，签到，购买商品</div>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- <div class="content mt-24" v-if="this.$route.path == '/admin/assembly'">
            <div class="title_other">其他模块</div>
            <div class="display_flex mt-24 mb-24">
                <div class="card_other" @click="goTurntable">
                    <img src="../../assets/big_turntable.png">
                    <div class="display_flex flex-col">
                        <div class="card_title">大转盘</div>
                        <div>买一件商品获得转盘机会一次</div>
                    </div>
                </div>
            </div>
        </div> -->
        <template>
            <router-view></router-view>
        </template>
    </div>
</template> 

<script>
// import {} from '@/api/index';
export default {
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        goWxpacket(){
            this.$router.push({ path: "/admin/assembly/wxpacket" });
        },
        // goIntegral(){
        //     this.$router.push({ path: "/admin/assembly/integral" });
        // },
        // goTurntable(){
        //     this.$router.push({ path: "/admin/assembly/turntable" });
        // },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
}
.title:before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #FF761D;
    border-radius: 5px;
    margin-right: 5px;
}
.title_other {
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
}
.title_other:before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #77A4E9;
    border-radius: 5px;
    margin-right: 5px;
}
.card {
    padding: 12px;
    background: #FFF2EA;
    border-radius: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.card_other {
    padding: 12px;
    background: #F2F5FF;
    border-radius: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.display_flex {
    display: flex;
}
.card_title {
    font-weight: bold;
    font-size: 20px;
    color: #484E66;
}
</style>